/**
 * Testing Service
 * API client för testhantering
 */

import api from './client';

export interface TestRunRequest {
  testPattern?: string;
  testFile?: string;
  all?: boolean;
}

export interface TestResult {
  id: string;
  timestamp: string;
  status: 'running' | 'completed' | 'failed';
  testPattern?: string;
  testFile?: string;
  all?: boolean;
  summary?: {
    total: number;
    passed: number;
    failed: number;
    duration: number;
  };
  output?: string;
  error?: string;
  tests?: Array<{
    name: string;
    status: 'passed' | 'failed';
    duration?: number;
    error?: string;
  }>;
}

/**
 * Kör tester asynkront
 */
export const runTests = async (request: TestRunRequest): Promise<{ id: string }> => {
  const response = await api.post<{ success: boolean; data: { id: string }; message: string }>(
    '/api/testing/run',
    request
  );
  return response.data.data;
};

/**
 * Hämta alla testresultat
 */
export const getTestResults = async (): Promise<TestResult[]> => {
  const response = await api.get<{ success: boolean; data: TestResult[] }>('/api/testing/results');
  return response.data.data;
};

/**
 * Hämta specifikt testresultat
 */
export const getTestResult = async (id: string): Promise<TestResult> => {
  const response = await api.get<{ success: boolean; data: TestResult }>(`/api/testing/results/${id}`);
  return response.data.data;
};

/**
 * Ta bort testresultat
 */
export const deleteTestResult = async (id: string): Promise<void> => {
  await api.delete(`/api/testing/results/${id}`);
};

/**
 * Ta bort alla testresultat
 */
export const deleteAllTestResults = async (): Promise<{ deleted: number }> => {
  const response = await api.delete<{ success: boolean; data: { deleted: number }; message: string }>(
    '/api/testing/results'
  );
  return response.data.data;
};

/**
 * Ladda upp testresultat från fil
 */
export const uploadTestResult = async (file: File): Promise<TestResult> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post<{ success: boolean; data: TestResult; message: string }>(
    '/api/testing/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data.data;
};

